export default {
  SERVER: 'https://agfintechportal.com'
}